import { Log } from "../generic";

export enum StepToReturnStep8Enum {
  STEP_5 = 5,
  STEP_6 = 6,
  STEP_7 = 7,
}

export interface CreateStep8Body {
  closure_approval_comment: string;
  closure_approved: boolean | null;
  step_to_return: StepToReturnStep8Enum | null;
  wos_closed: boolean | null;
  draft: boolean;
}

export interface Step8Response extends CreateStep8Body, Log {
  cto_code: string;
  can_user_fill_step: boolean;
  eligible_users?: string[];
}
